import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { SectionHelper, Text, TextButton } from '@wix/design-system';
import { useBiLogger } from '../../providers/BiLoggerProvider';
import { useUnknownChargeContext } from '../../providers/UnknownChargeProvider';
import { serializeRequestParams } from '../../utils';

export const Consolidated: React.FC = () => {
  const {
    chargeDetails: { invoiceNumber },
  } = useUnknownChargeContext();
  const { biLogger } = useBiLogger();
  useEffect(() => {
    biLogger.consolodatedView({ invoiceNumber });
  }, []);
  const params = {
    nodeId: '6254QgtObtQj40ReG5w6',
    referalInfo: 'unknown-charge',
    _invoiceNumber: invoiceNumber,
  };

  const logBI = () => {
    biLogger.notFoundClick({ invoiceNumber });
  };
  return (
    <SectionHelper
      appearance="standard"
      dataHook="charge-details__consolidated"
    >
      <Text size="small">
        <Trans i18nKey="charge-locator.results_page.consolidated_invoices.section_helper.contact_customer_care">
          charge-locator.results-page.consolidated-invoices.section-helper.
          <TextButton
            as="a"
            size="small"
            underline="always"
            skin="dark"
            onClick={logBI}
            href={`//www.wix.com/support-chatbot${serializeRequestParams(
              params,
            )}`}
          >
            contact-customer-care
          </TextButton>
        </Trans>
      </Text>
    </SectionHelper>
  );
};
